import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Users } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { Field, PanelShell, TextInput } from "@/components/admin/ui";

const fmtDate = (iso) => {
  try {
    return new Date(iso).toLocaleString("zh-CN", { dateStyle: "medium", timeStyle: "short" });
  } catch {
    return iso;
  }
};

export const SubscribersPanel = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () =>
    api
      .get("/subscribers")
      .then((r) => setItems(r.data))
      .catch((e) => toast.error(formatApiError(e)))
      .finally(() => setLoading(false));

  useEffect(() => {
    load();
  }, []);

  const remove = async (id, email) => {
    if (!window.confirm(`确定删除订阅者「${email}」？`)) return;
    try {
      await api.delete(`/subscribers/${id}`);
      toast.success("已删除");
      load();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  if (loading) return <p className="font-mono2 text-xs text-[#a1a1aa] tracking-[0.3em]">LOADING…</p>;

  return (
    <PanelShell title={`订阅观众 (${items.length})`}>
      {items.length === 0 ? (
        <div className="border border-dashed border-white/15 py-20 text-center">
          <p className="font-zh text-[#a1a1aa]">暂无订阅 — 观众在官网「演出日历」订阅后会出现在这里</p>
        </div>
      ) : (
        <div className="space-y-2" data-testid="admin-subscribers-list">
          {items.map((s) => (
            <div key={s.id} className="flex items-center justify-between gap-4 border border-white/10 bg-[#0a0a0a] px-4 py-3" data-testid={`subscriber-row-${s.id}`}>
              <div className="min-w-0">
                <div className="flex items-center gap-3 flex-wrap">
                  <Users size={14} className="text-[#ffde00]" />
                  <span className="font-mono2 text-sm text-white">{s.email}</span>
                  <span className={`font-mono2 text-[9px] px-1.5 py-0.5 ${s.active ? "bg-[#ffde00] text-black" : "bg-white/10 text-[#a1a1aa]"}`}>
                    {s.active ? "订阅中" : "已退订"}
                  </span>
                </div>
                <div className="font-mono2 text-[10px] text-[#52525b] mt-1">{fmtDate(s.created_at)}</div>
              </div>
              <button
                onClick={() => remove(s.id, s.email)}
                className="text-[#a1a1aa] hover:text-red-400 bg-transparent border-0 cursor-pointer p-1"
                data-testid={`subscriber-delete-${s.id}`}
                aria-label="删除"
              >
                <Trash2 size={15} />
              </button>
            </div>
          ))}
        </div>
      )}
    </PanelShell>
  );
};

export { Field, TextInput };
